import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import ENV from '../../env'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    attendances: [],
    attendance: {}
  },
  mutations: {
    index(state, payload) {
      state.attendances = payload
    },
    show(state, payload) {
      state.attendance = payload
    }
  },
  actions: {
    index({ commit }) {
      axios.get(`${ENV.API_URL}/api/attendances`).then((res) => {
        commit('index', res.data)
      })
    },
    show({ commit }, payload) {
      axios.get(`${ENV.API_URL}/api/attendances/${payload}`).then((res) => {
        commit('show', res.data)
      })
    },
    create({ commit }, payload) {
      axios.post(`${ENV.API_URL}/api/attendances`, payload).then((res) => {
        commit('show', res.data)
      })
    },
    uptade({ commit }, payload) {
      axios.put(`${ENV.API_URL}/api/attendances/${payload.id}`, payload).then((res) => {
        commit('show', res.data)
      })
    }
  },
  getters: {
    attendances: state => {
      return state.attendances
    },
    attendance: state => {
      return state.attendance
    }
  },
  modules: {
  }
}
